<template>
    <v-dialog
        title="Fotoğraf yükle"
        v-model="visible"
        content-class="mak-upload-dialog"
        transition="dialog-bottom-transition"
        fullscreen
        hide-overlay
    >
        <v-card :loading="uploading" :disabled="uploading">
            <v-toolbar
                dark
                color="deep-purple"
            >
                <v-btn
                    icon
                    dark
                    @click="close"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Makina Fotoğraf Yükle</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="close"
                    >
                        Kapat
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <div class="pa-6">
                <div class="flex justify-center align-center">
                    <v-file-input
                        v-model="selection"
                        placeholder="Makina fotoğrafları yükleyin"
                        label="Makina fotosu"
                        prepend-icon="mdi-camera"
                        color="deep-purple"
                        @change="upload"
                    >
                        <template v-slot:selection="{ text }">
                            <v-chip
                                small
                                label
                                color="deep-purple accent-2"
                                dark
                            >
                                {{ text }}
                            </v-chip>
                        </template>
                    </v-file-input>
                </div>

                <v-alert
                    v-if="!files.length"
                    class="mt-4"
                    color="blue-grey lighten-1"
                    dark
                >
                    Henüz hiç foto eklenmedi!
                </v-alert>

                <v-card v-else class="pa-4 mt-4">
                    <p>Yüklenen Fotoğraflar</p>

                    <v-carousel
                        v-model="carousel"
                        hide-delimiters
                    >
                        <v-carousel-item
                            v-for="(f, ind) in files"
                            :key="ind"
                        >
                            <v-img
                                :src="host + f.src"
                                max-height="500"
                                contain
                                class="grey lighten-3"
                            />
                        </v-carousel-item>
                    </v-carousel>

                    <div class="mak-upload-total pa-8">
                        Toplam foto: {{ files.length }}
                    </div>
                </v-card>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import { getApiUrl } from '@/common/configs';

    export default {
        name: 'mak-upload',
        model: {
            props: 'value',
            event: 'change',
        },
        props: {
            value: {type: Boolean, required: true},
            makinaId: {type: [Number, String], required: true},
        },
        data() {
            return {
                visible: false,
                uploading: false,
                selection: [],
                files: [],
                carousel: 0,
                host: getApiUrl(),
            };
        },
        computed: {
        },
        methods: {
            handleChange(files) {
                const { success } = files.response || {};
                if (success) {
                    this.files.unshift(success);
                }
            },
            close() {
                this.visible = false;
            },
            upload() {
                this.uploading = true;
                const file = arguments[0];
                if (!file) {
                    return;
                }
                this.$requests.MakinaFoto
                    .upload(this.makinaId, file)
                    .then((data) => {
                        const { src } = data || {};
                        if (src) {
                            this.files.unshift({ src });
                        }
                    })
                    .catch((error) => {
                        console.error('err', error);
                    })
                    .finally(() => {
                        this.uploading = false;
                    });
            },
        },
        mounted() {
            this.visible = this.value;
        },
        watch: {
            value() {
                this.visible = this.value;
            },
            visible() {
                if (this.value !== this.visible) {
                    this.$emit('change', this.visible);
                }

                //
                if (!this.visible) {
                    this.files = [];
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    ::v-deep .el-dialog__body {
        padding: 0;
    }

    .mak-upload-input {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        height: 120px;
        width: 160px;
        &:hover {
            border-color: #409EFF;
        }
    }

    ::v-deep .el-carousel__container {
        height: 600px;
        .el-carousel__item {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .mak-upload-total {
        display: flex;
        justify-content: flex-end;
    }
</style>
